import { SerializedBoardData } from "../../models/board.types";
import { CategoryData } from "../../models/category.types";
import { SerializedItemData } from "../../models/item.types";
import { SerializedSessionData } from "../../models/session.types";

export interface ModalPayloadMap {
  configureSession:        { sessionData: SerializedSessionData }
  confirmDeleteAccount:    Record<string, never>
  confirmShredBoard:       { boardData: SerializedBoardData }
  confirmShredSession:     { sessionData: SerializedSessionData }
  confirmUnsubscribeBoard: { boardUid: string; userUid: string }
  createOrEditBoard:       { boardData?: SerializedBoardData }
  createOrEditCategory:    { categoryData?: CategoryData }
  createOrEditItem:        { categoryData: CategoryData; itemData?: SerializedItemData }
  boardMembers:            { boardUid: string; ownerUid: string }
  editProfile:             { name: string }
  features:                Record<string, never>
  loadingSession:          Record<string, never>
  presentationTime:        { boardUid: string; sessionUid: string; firstItemUid: string }
  resetPassword:           Record<string, never>
  shareBoard:              { boardUid: string }
}

export type ModalKind = keyof ModalPayloadMap

export type ModalData = { [K in ModalKind]: { kind: K } & ModalPayloadMap[K] }[ModalKind]

type Equals<A, B> = [A] extends [B] ? [B] extends [A] ? true : false : false
type EmptyPayloadKind = { [K in ModalKind]: Equals<ModalPayloadMap[K], Record<string, never>> extends true ? K : never }[ModalKind]
type NonEmptyPayloadKind = Exclude<ModalKind, EmptyPayloadKind>

export function modal(kind: EmptyPayloadKind): ModalData;
export function modal<K extends NonEmptyPayloadKind>(kind: K, payload: ModalPayloadMap[K]): ModalData;
export function modal<K extends ModalKind>(kind: K, payload?: ModalPayloadMap[K]): ModalData {
  return { kind, ...payload } as ModalData;
}
